import { getBrowserSupabaseClient } from "@west-tennessee-consulting/supabase";
import { Company, CompanyInsert, CompanyUpdate } from "@/lib/hooks/api/companies";

export const fetchCompanyById = async (companyId: string): Promise<Company | null> => {
  const supabase = getBrowserSupabaseClient();
  const { data, error } = await supabase
    .from("companies")
    .select("*")
    .eq("id", companyId)
    .single();

  if (error && error.code !== "PGRST116") {
    // PGRST116 means no rows found, which is not an error in this case.
    throw error;
  }

  return data;
};

export const createCompany = async (companyData: CompanyInsert): Promise<Company> => {
  const supabase = getBrowserSupabaseClient();
  const { data, error } = await supabase.from("companies").insert(companyData).single();

  if (error) {
    throw error;
  }

  return data;
};

export const updateCompany = async (
  companyData: CompanyUpdate,
  companyId: string
): Promise<Company> => {
  const supabase = getBrowserSupabaseClient();
  const { data, error } = await supabase
    .from("companies")
    .update(companyData)
    .eq("id", companyId)
    .single();

  if (error) {
    throw error;
  }

  return data;
};
